export default "__VITE_ASSET__543df085__"